/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { useState } from 'preact/hooks';
import { useTooltipControlled } from '../UNSAFE_useTooltip';

export function useMeterDatatip(value: number, datatip?: string | null, ariaDescribedBy?: string) {
  const datatipText = datatip === null ? '' : datatip === undefined ? `${value}` : datatip;
  const [isDatatipOpen, setDatatipOpen] = useState<boolean>(false);
  const { tooltipContent, tooltipProps } = useTooltipControlled({
    text: datatipText,
    isOpen: isDatatipOpen,
    position: 'top',
    isDisabled: datatip === null,
    anchor: { x: 'pointer', y: 'pointer' },
    variant: 'datatip',
    offset: {
      mainAxis: 8,
      crossAxis: 0
    },
    onToggle: ({ value }) => setDatatipOpen(value)
  });

  tooltipProps['aria-describedby'] = [ariaDescribedBy, tooltipProps['aria-describedby']]
    .filter(Boolean)
    .join(' ');

  return { datatipContent: tooltipContent, datatipProps: tooltipProps };
}
